module.exports = __webpack_public_path__ + "static/media/facebook.1956529c.svg";